<template>
    <!-- Subscription canceled: show 0 day -->
    <span class="sub-status subscription-expired" v-if="isCaneclled">
        0 {{ i18n.t('symbole.day') }}
    </span>
    <span class="sub-status" v-else-if="status?.comment === 'not_started' && daysToStart !== null">
      {{ daysToStart }} {{ i18n.t('symbole.day') }}
    </span>
    <span class="sub-status" v-else-if="status?.comment === 'paused' && activePausedDays !== null" >
        {{ activePausedDays }} {{ i18n.t('symbole.day') }}
    </span>
    <!-- Remaining days -->
    <span class="sub-status" v-else-if="remainingDays !== null"
        :class="remainingDays <= 0 ? 'subscription-expired' : 'subscription-active'">
        {{ remainingDays }} {{ i18n.t('symbole.day') }}
    </span>
   

    <!-- Session-type display -->
    <template v-if="isSession">
        <span class="sub-status" v-if="limited !== null">
            {{ limited }} {{ label }}
        </span>
        <span class="sub-status">
            {{ consumed }} {{ label }} consommé
        </span>
        <span class="sub-status" :class="remaining <= 0 ? 'subscription-expired' : 'subscription-active'">
            {{ remaining }} {{ label }} restants
        </span>
    </template>

    <!-- Points-type display -->
    <template v-if="isPoints">
        <span class="sub-status" v-if="limited !== null">
            {{ limited }} {{ label }}
        </span>
        <span class="sub-status">
            {{ consumed }} {{ label }} consommé
        </span>
        <span class="sub-status" :class="remaining <= 0 ? 'subscription-expired' : 'subscription-active'">
            {{ remaining  }} {{ label }} restants
        </span>
    </template>

    <!-- Optional comment -->
    <span class="sub-status" v-if="isCaneclled">
        {{ status?.comment  ?? ''}}
    </span>
    <span class="sub-status" v-else-if="status?.comment">
        {{ i18n.t('comment.' + status.comment) }}
    </span>
</template>

<script setup lang="ts">
import { defineProps, computed } from 'vue';
import i18n from '@/i18n/index';
import { SubscriptionMember } from "@/interfaces/subscriptionMember";

const props = defineProps<{
    subscription: SubscriptionMember | null;
}>();

const sub = computed(() => props.subscription);
const status = computed(() => sub.value?.status ?? null);

const isSession = computed(() => sub.value?.status?.type === 'session');
const isPoints = computed(() => sub.value?.status?.type === 'points');
const isCaneclled = computed(() => (sub.value?.status?.type === 'canceled' || sub.value?.status?.type === 'transfer'));
//const isMonthly = computed(() => sub.value?.status?.type === 'monthly');

const remainingDays = computed(() => (status.value?.remaining_days && status.value?.remaining_days > 0) ? status.value?.remaining_days : 0);
const daysToStart = computed(() => status.value?.days_to_start ?? null);
const activePausedDays = computed(() => status.value?.current_pause_days ?? null);
 
const remaining = computed(() =>
    isSession.value
        ? status.value?.remaining_seances ?? 0
        : isPoints.value
            ? status.value?.remaining_points ?? 0
            : 0
);
const limited = computed(() =>
    isSession.value
        ? sub.value?.limited_sessions ?? null
        : isPoints.value
            ? sub.value?.limited_points ?? null
            : null
);
const consumed = computed(() =>
    isSession.value
        ? sub.value?.consumed_sessions ?? 0
        : isPoints.value
            ? sub.value?.consumed_points ?? 0
            : 0
);
const label = computed(() =>
    isSession.value
        ? i18n.t('symbole.seance')
        : isPoints.value
            ? i18n.t('symbole.point')
            : ''
);
</script>

<style>
.subscription-expired,
.subscription-active {
    color: #fff;
    display: inline-block !important;
    padding: 4px 6px;
}

.subscription-expired {
    background-color: #e3342f;
    padding: 4px 6px;
}

.subscription-active {
    background-color: #38c172;
    padding: 4px 6px;
}

.sub-status {
    display: block;
    font-weight: 700;
    line-height: 1;
    white-space: nowrap;
   
    font-size: 85%;
    border-radius: 0.25rem;
}
</style>
